module.exports = __webpack_public_path__ + "assets/b423bfc4fb55dbd7eb06fca61bc986ed.png";